module.exports = __webpack_public_path__ + "media/src/images/partners/wwf-1741ed327480990196e3a8090787e2b7.jpg";